import { cn } from '../../utils'

export const getPopperClassName = () => {
    return 'h-[340px] left-0 outline-none rounded-lg flex-col justify-start items-start inline-flex focus:outline-none bg-background-base shadow-modal'
}

export const getPickerClassName = () => {
    return 'font-sans border-none text-light font-bold font-sans outline-none h-[40px] bg-background-base shadow-modal'
}

export const getPickerInputStyle = (disabled: boolean): string => {
    return cn(
        'inline-flex h-[50px] w-full flex items-center justify-between rounded-[30px] border-none bg-background-base py-0.5 pl-[25px] pr-5 font-sans text-slate-600 shadow-modal focus:outline-none',
        disabled && 'bg-background-disabled/20 shadow-none'
    )
}

export const getPickerHeader = () => {
    return 'inline-flex h-[50px] w-full items-center justify-between rounded-tl-md rounded-tr-md bg-background-base p-2.5 shadow-modal'
}
